import React from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';
import { toast as sonnerToast } from 'sonner';

import { cn } from '../components/lib/utils';

const errorStyles = {
  iconVariant: 'fa-regular fa-circle-exclamation',
  iconColor: 'text-base-destructiveForeground',
  toastBackground: 'bg-base-destructive border-base-destructive',
  textColor: 'text-base-destructiveForeground'
};

export const showValidationToast = ({
  message,
  descriptions
}: {
  message: string;
  descriptions: string[];
}) => {
  return sonnerToast(message, {
    duration: 10000,
    description: (
      <ul className="mt-1 flex flex-col gap-0.5">
        {descriptions.map((desc, i) => (
          <li key={i}>{desc}</li>
        ))}
      </ul>
    ),
    unstyled: true,
    closeButton: true,
    icon: (
      <FontAwesomeIcon
        icon={errorStyles.iconVariant}
        className={cn('mt-1', errorStyles.iconColor)}
      />
    ),
    classNames: {
      toast: cn(
        'group flex items-center py-6 pl-6 pr-8 border rounded-md gap-y-1 gap-x-4 w-[388px] absolute hover:cursor-pointer shadow-lg bottom-0 h-max [&:not(:first-child)>div]:data-[expanded=false]:opacity-0',
        errorStyles.toastBackground
      ),
      title: cn(
        'text-p-s font-semibold opacity-100',
        errorStyles.textColor
      ),
      description: cn(
        'opacity-90 text-p-s',
        errorStyles.textColor
      ),
      closeButton: cn(
        'opacity-0 group-hover:opacity-100 absolute top-3 right-3 w-4 h-4 [&>svg]:h-4 [&>svg]:w-4',
        errorStyles.iconColor
      )
    }
  });
};
